import { render, staticRenderFns } from "./galleryBlock.vue?vue&type=template&id=f76a42da&scoped=true&"
import script from "./galleryBlock.vue?vue&type=script&lang=js&"
export * from "./galleryBlock.vue?vue&type=script&lang=js&"
import style0 from "./galleryBlock.vue?vue&type=style&index=0&id=f76a42da&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f76a42da",
  null
  
)

export default component.exports